export default __webpack_public_path__ + "static/IBMPlexSans-Text-Cyrillic-cf1b77077b32d158a936d60ccce93db8.woff2";